var _circle, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerinprocess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#37AB34"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.76983,
    y: 3.00018,
    width: 0.461538,
    height: 3.23077,
    fill: "#37AB34",
    stroke: "#37AB34",
    strokeWidth: 0.461538
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.07587,
    y: 6.69256,
    width: 0.461538,
    height: 2.30769,
    transform: "rotate(90 8.07587 6.69256)",
    fill: "#37AB34",
    stroke: "#37AB34",
    strokeWidth: 0.461538
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerinprocess);
export default __webpack_public_path__ + "static/media/timerinprocess.a50bb85312eb529d3cdda8f152c9a550.svg";
export { ForwardRef as ReactComponent };